import { render } from "./CountryCodePage.vue?vue&type=template&id=4ec1badb&scoped=true"
import script from "./CountryCodePage.vue?vue&type=script&lang=js"
export * from "./CountryCodePage.vue?vue&type=script&lang=js"

import "./CountryCodePage.vue?vue&type=style&index=0&id=4ec1badb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec1badb"]])

export default __exports__